import { render } from "./CreateLiquidation3.vue?vue&type=template&id=74dd5817"
import script from "./CreateLiquidation3.vue?vue&type=script&lang=js"
export * from "./CreateLiquidation3.vue?vue&type=script&lang=js"

import "./CreateLiquidation3.vue?vue&type=style&index=0&id=74dd5817&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__